import { useState } from "react";
import { editRoutine, getUser, getUserRoutines } from "../api";

export default function EditRoutine ({token, setEditRoutine, routineId, editName, editGoal, setEditName, setEditGoal, setUser, setUserRoutines}) {

    const editingRoutine = async () => {
        try {
            const result = await editRoutine(token, routineId, editName, editGoal);
            console.log(result);
            return result;
        } catch (err) {
            console.log(err, "Unable to post routine.")
        }
    };

    const gettingUserAndRoutines = async () => {
        try {
            const userResult = await getUser(token);
            setUser(userResult.username);
            const userRoutinesResult = await getUserRoutines(userResult.username);
            setUserRoutines(userRoutinesResult);
        } catch (err) {
            console.error("Failed to fetch user data or user routines", err);
        }     
    };
    
    return <form className="makeRoutine" onSubmit={event => {
        event.preventDefault();
        editingRoutine();
        setEditName("");
        setEditGoal("");
        setEditRoutine(false);
        gettingUserAndRoutines();
    }}>
        <h2>Edit Routine</h2>
        <div className="form-element">
            <label htmlFor="create-title">Name</label>
            <input id="create-name" name="name" value={editName} type="text" placeholder="What is the name of your routine?" required onChange={event => {setEditName(event.target.value)}}/>
        </div>
        <div className="form-element">
            <label htmlFor="create-goal">Goal</label>
            <textarea id="create-goal" name="create-goal" value={editGoal} required onChange={event => {setEditGoal(event.target.value)}}></textarea>
        </div>
        <button type="submit" className="form-button">Submit</button>
        <button type="button" className="form-button" onClick={((event) => {
            event.preventDefault();
            setEditRoutine(false);
        })}> Cancel</button>
    </form> 

}